import { notifyError } from "../components/Toast";
import { fetchWithAuth } from '../auth/fetchWithAuth';
import FACULTIES_BLACK_LIST from '../enums/FacultiesBlackList';

export const getFacultadesResume = (processId,user) => {
  return async (dispatch) => {
    dispatch({ type: "GET_FACULTADES_RESUME_REQUEST" });

    try {
      
      const response = await fetchWithAuth(`${process.env.REACT_APP_API_BASE_URL}reportes/${processId}/evaluacion/facultades/resume`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + user.token
          },
        },dispatch
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al obtener las facultades");
      }

      const data = await response.json();

      const dataFiltered = data.filter((fac) => !FACULTIES_BLACK_LIST.includes(fac.Codigo.toUpperCase()))

      dispatch({ type: "GET_FACULTADES_RESUME_SUCCESS", payload: dataFiltered });

    } catch (error) {
      notifyError("Error al obtener las facultades");
      dispatch({ type: "GET_FACULTADES_RESUME_FAIL", payload: error.message });
    }
  };
};

export const getAllCriteriosResume = (processId,cod,sede,user) => {
  return async (dispatch) => {
    dispatch({ type: "GET_CRITERIOS_EVALUACIONES_REQUEST" });

    try {
      const query = new URLSearchParams({
        codigo: cod,
        sede: sede ? sede : '',
      }).toString();

      const response = await fetchWithAuth(`${process.env.REACT_APP_API_BASE_URL}reportes/${processId}/evaluacion/criterios/resume?${query}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + user.token
          },
        },dispatch
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al obtener las facultades");
      }

      const data = await response.json();
      
      dispatch({ type: "GET_CRITERIOS_EVALUACIONES_SUCCESS", payload: data });

    } catch (error) {
      notifyError("Error al obtener las facultades");
      dispatch({ type: "GET_CRITERIOS_EVALUACIONES_FAIL", payload: error.message });
    }
  };
};


export const getPlanMejoraByCodigo = (codigoFacultad, codigoCarrera, user) => {
  return async (dispatch) => {
    dispatch({ type: "GET_PLAN_MEJORA_REQUEST" });

    try {
      const query = new URLSearchParams({
        codigoFacultad,
        codigoCarrera,
      }).toString();

      const response = await fetchWithAuth(`${process.env.REACT_APP_API_BASE_URL}plan-mejora/especificacion?${query}`, {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al obtener el plan de mejora");
      }

      const data = await response.json();

      dispatch({ type: "GET_PLAN_MEJORA_SUCCESS", payload: data });
    } catch (error) {
      notifyError("Error al obtener el plan de mejora");
      dispatch({ type: "GET_PLAN_MEJORA_FAIL", payload: error.message });
    }
  };
};